import React from "react";
import { Controller } from "react-hook-form";
import FIlterSelect from "../filter-select";
import Input from "../input";
import Textarea from "../textarea";

interface Details {
    control: any;
    clearErrors: any;
    errors: any;
    discount: any;
}
const DiscountInformation: React.FC<Details> = ({ control, discount }) => {
    return ( 
        <div className="flex flex-col gap-5">
           <div className="items-center gap-4">
                <Controller
                name="name"
                defaultValue={discount?.name}
                control={control}
                rules={{
                    required: "Discount is required",
                }}
                render={({ field, fieldState }) => (
                    <Input
                    value={field.value}
                    className="w-full"
                    label="Discount Name"
                    placeholder="Enter Discount Name"
                    error={fieldState?.error?.message}
                    onChange={field.onChange}
                    />
                )}
                />
            </div>

            <div className="items-center gap-4">
                <Controller
                    name="discountType"
                    defaultValue={discount?.discountType}
                    control={control}
                    render={({ field }) => (
                    <FIlterSelect
                        name="discountType"
                        options={[
                        { value: "fixed-amount", label: "Fixed" },
                        { value: "percentage", label: "Percentage" },
                        ]}
                        className="w-full"
                        label="Discount Type"
                        onChange={(selectedValue) => {
                        field.onChange(selectedValue);
                        }}
                        value={field.value}
                    />
                    )}
                />
            </div>

            <div className="items-center gap-4">
                <Controller
                name="discountValue"
                defaultValue={discount?.discountValue}
                control={control}
                rules={{
                    required: "Discount value is required",
                }}
                render={({ field, fieldState }) => (
                    <Input
                        value={field.value}
                        className="w-full"
                        label="Discount Value"
                        placeholder="Enter Discount Value"
                        error={fieldState?.error?.message}
                        onChange={field.onChange}
                    />
                )}
                />
            </div>
            <div className="items-center gap-4">
                <Controller
                name="startDate"
                defaultValue={discount?.startDate}
                control={control}
                rules={{
                    required: "Start date is required",
                }}
                render={({ field, fieldState }) => (
                    <Input
                        value={field.value}
                        type="date"
                        min={new Date().toISOString().split('T')[0]}
                        className="w-full"
                        label="Start Date"
                        placeholder="Enter Start Date"
                        error={fieldState?.error?.message}
                        onChange={field.onChange}
                    />
                )}
                />
            </div>
            <div className="items-center gap-4">
                <Controller
                name="endDate"
                defaultValue={discount?.endDate}
                control={control}
                rules={{
                    required: "End date is required",
                }}
                render={({ field, fieldState }) => (
                    <Input
                        value={field.value}
                        type="date"
                        min={new Date().toISOString().split('T')[0]}
                        className="w-full"
                        label="End Date"
                        placeholder="Enter End Date"
                        error={fieldState?.error?.message}
                        onChange={field.onChange}
                    />
                )}
                />
            </div>

            <div className="items-center gap-4">
                <Controller
                    name="discountCode"
                    defaultValue={discount?.discountCode}
                    control={control}
                    rules={{
                        required: "Discount code is required",
                    }}
                    render={({ field, fieldState }) => (
                        <Input
                            value={field.value}
                            className="w-full"
                            label="Discount Code"
                            placeholder="Enter Discount Code"
                            error={fieldState?.error?.message}
                            onChange={field.onChange}
                        />
                    )}
                />
            </div>
            <div className="items-center gap-4">
                <Controller
                    name="Description"
                    defaultValue={discount?.description}
                    control={control}
                    rules={{
                        required: "Description is required",
                    }}
                    render={({ field, fieldState }) => (
                        <Textarea
                            value={field.value}
                            className="w-full"
                            label="Description"
                            placeholder="Enter description"
                            error={fieldState?.error?.message}
                            onChange={field.onChange}
                        />
                    )}
                />
            </div>
        </div>

     );
}
 
export default DiscountInformation;